import OOutgoingCallModal from './index.vue';

OOutgoingCallModal.install = app => {
  app.component(OOutgoingCallModal.name, OOutgoingCallModal);
};

export default OOutgoingCallModal;
